/**
 * Threads map for the three assessments types - MATHS_JUNIOR_HIGH, MATHS_SENIOR_PRIMARY, MATHS_JUNIOR_PRIMARY
 */
const defaultThreads = [
  "Numbers",
  "Fractions",
  "Measurement",
  "Data Literacy",
  "Problem Solving",
  "Patterns & Algebra",
  "Space & Shape"
];

/**
 * Threads map for Adult Numeracy - MATHS_ADULT_NUMERACY
 */
const adultNumeracyThreads = [
  "Numerical Competence",
  "Proportional Reasoning",
  "Measurement Skills",
  "Space & Shape",
  "Data Literacy",
  "Generalised Thinking",
  "Problem Solving"
];

/**
 * Threads map for English
 */
const englishThreads = [
  "Visual Communication", //Oral Comprehension & Communication
  "Oral Comprehension", //Written Comprehension & Communication
  "Written Comprehension", // Comprehension & Communication
  "Language Structure" //Language Structure
];

/**
 * Max level for each assessment Type
 */
const levels = {
  MATHS_JUNIOR_HIGH: 9,
  MATHS_SENIOR_PRIMARY: 6,
  MATHS_JUNIOR_PRIMARY: 3,
  MATHS_ADULT_NUMERACY: 9,
  ENGLISH_JUNIOR_HIGH: 9,
  ENGLISH_SENIOR_PRIMARY: 6
};

/**
 * Threads array
 * @param {number | string} grade
 * @param {string} currentAssessment
 * @return {Array} Thread map based on grade.
 * If the grade is not grade 13 - return default threads, otherwise return adult numeracy threads.
 *
 */
const threads = (grade, currentAssessment) => {
  if (currentAssessment.startsWith("ENGLISH")) {
    return englishThreads;
  }
  if (grade != 13) return defaultThreads;
  return adultNumeracyThreads;
};

const assessmentLevelsMap = assessmentType => {
  return levels[assessmentType] ? levels[assessmentType] : 9;
};

export { threads, assessmentLevelsMap };
